import { dropdownItemLabel } from "../dropdown.shared.styles.js";
import { menuItem } from "./menu.styles.js";
import { c } from "react/compiler-runtime";
import { jsx } from "react/jsx-runtime";
import { Menu } from "@base-ui/react/menu";
//#region src/components/menu/menu.item.tsx
/** An action within a Menu. */
var MenuItem = (t0) => {
	const $ = c(10);
	let children;
	let itemProps;
	let t1;
	if ($[0] !== t0) {
		const { children: t2, render, ...t3 } = t0;
		children = t2;
		itemProps = t3;
		t1 = typeof render === "function" ? (props, state) => render(props, {
			disabled: state.disabled,
			highlighted: state.highlighted
		}) : render;
		$[0] = t0;
		$[1] = children;
		$[2] = itemProps;
		$[3] = t1;
	} else {
		children = $[1];
		itemProps = $[2];
		t1 = $[3];
	}
	const resolvedRender = t1;
	let t2;
	if ($[4] !== children) {
		t2 = /* @__PURE__ */ jsx("span", {
			className: dropdownItemLabel,
			children
		});
		$[4] = children;
		$[5] = t2;
	} else t2 = $[5];
	let t3;
	if ($[6] !== itemProps || $[7] !== resolvedRender || $[8] !== t2) {
		t3 = /* @__PURE__ */ jsx(Menu.Item, {
			...itemProps,
			className: menuItem,
			render: resolvedRender,
			children: t2
		});
		$[6] = itemProps;
		$[7] = resolvedRender;
		$[8] = t2;
		$[9] = t3;
	} else t3 = $[9];
	return t3;
};
//#endregion
export { MenuItem };
